import { setStepName } from './set-step-name';
import { RootScopeEvents } from '../../../common/services/root-scope-types';
import { AngularServices, getAngularService, } from '../../core/helpers/get-angular-service';
let isSetToAutoClose = false;
export const autoCloseTroubleshootingOnSessionEnd = () => (dispatch) => {
    if (isSetToAutoClose)
        return;
    isSetToAutoClose = true;
    const $rootScope = getAngularService(AngularServices.RootScope);
    const globalUi = getAngularService(AngularServices.GlobalUi);
    $rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, () => {
        if (!globalUi.ui.isRestartingCall) {
            dispatch(setStepName(null));
        }
    });
};
